import React from "react";
import { BrowserRouter, Routes, Route, Router } from "react-router-dom";
import LoginPage from "./page/auth/LoginPage";
import Register from "./page/auth/Register";
import axios from "axios";
import Shop from "./page/Products/Shop";
import { ProtectedRoute } from "./utils/ProtectedRoute";
import Navbar from "./components/Navbar/Navbar";
import ScrollTop from "./components/scrollTop/ScrollTop";
import Footer from "./components/Footer/Footer";
import Product from "./page/Product/Product";
import Payment from "./page/checkOut/Payment";
import Home from "./page/Home/Home";
import Offer from "./page/Products/Offer";
import Conditions from "./page/t&c/Conditions";
import PrivacyPolicy from "./page/Policy/PrivacyPolicy";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import About from "./page/About/About";
import Contact from "./page/Contact/Contact";
import CheckoutDone from "./page/checkoutDone/CheckoutDone";
import useGTMPageView from "./utils/useGTMPageView";
import Whatapp from "./components/whatapp/Whatapp";
import MobileCart from "./components/mobileCart/MobileCart";

// axios.defaults.baseURL = process.env.REACT_APP_AXIOS_LINK;
//axios.defaults.baseURL = "http://localhost:6021/api/v1";
axios.defaults.baseURL = "https://api.notionsgroup.com/api/v1";
axios.defaults.withCredentials = true;

const App = () => {
  useGTMPageView();
  return (
    <>
      <MobileCart />
      <Whatapp />
      <ScrollTop />
      <Navbar />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<Register />} />
        <Route path="*" element={<Home />} />
        <Route path="/offers" element={<Offer />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/about" element={<About />} />
        <Route path="/terms-&-conditions" element={<Conditions />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/check_out" element={<Payment />} />
        <Route path="/product/:slug" element={<Product />} />
        <Route path="/complete" element={<CheckoutDone />} />
      </Routes>
      <Footer />
      {/* Toast Container (must be inside the app) */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default App;
